<div class="chat-response chat-response-error" [innerHTML]="renderMarkdown(response.data)"></div>
